import React from 'react';
import { DotsContainer, Dot, Bar } from './PaginationDots.styles';

export interface PaginationDotsProps {
  currentIndex: number;
  totalSlides: number;
  goToSlide: (index: number) => void;
}

const PaginationDots: React.FC<PaginationDotsProps> = ({
  currentIndex,
  totalSlides,
  goToSlide,
}) => {
  return (
    <DotsContainer>
      {Array.from({ length: totalSlides }).map((_, index) => (
        <Dot
          aria-label={`Featured Offer ${index} of ${totalSlides}`}
          data-testid={`pagination-featured-offer${index}of${totalSlides}`}
          // CHANGE LATER - FIX
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          onClick={() => goToSlide(index)}
        >
          <Bar isActive={index === currentIndex} />
        </Dot>
      ))}
    </DotsContainer>
  );
};

export default PaginationDots;
